import React from "react"
import HirePage from "../components/HirePage"

export default () => <HirePage />
